import isIframe from './isIframe';

const isSoundcloudIframe = code => isIframe(code) && code.includes('soundcloud.com');

export default isSoundcloudIframe;
